import React from 'react'

const ChatButton = () => {
  return (
    <button className='border-[1px] pb-[5px] text-sm border-solid font-medium border-gray-300 rounded-3xl text-gray-500 h-fit px-[8px] py-[3px] hover:bg-[#EEE9FD] hover:border-[#EEE9FD] hover:text-[#6F47EB]'>
        Continue Chat
    </button>
  )
}

export default ChatButton